import { $translate } from '@/utils/i18n';
export default {
    configuration: true,
    searchList: {
        searchTxt: [],
        unfoldState: false,
        advancedBtn: true
    },
    table: {
        selectBtn: false,
        clickState: true,
        leftOperation: false,
        height: 400,
        columns: [
            {
                label: $translate('lang.E3202103250003', { defaultText: '模块名称' }),
                align: 'center',
                prop: 'moduleName',
                filter: true,
                require: true,
                width: 100
            },
            {
                label: $translate('lang.E3202103250004', { defaultText: '服务名称' }),
                align: 'center',
                prop: 'serviceName',
                filter: true,
                require: true,
                width: 100
            },
            {
                label: $translate('lang.E3202103250007', { defaultText: '服务描述' }),
                align: 'center',
                prop: 'serviceDesc',
                filter: true,
                require: true,
                width: 100
            },
            {
                label: $translate('lang.E3202103250008', { defaultText: '调用来源' }),
                align: 'center',
                prop: 'invokeFrom',
                filter: true,
                require: true,
                width: 100
            },
            {
                label: $translate('lang.E3202103250009', { defaultText: '请求地址' }),
                align: 'center',
                prop: 'requestUrl',
                filter: true,
                require: true,
                width: 100
            },
            {
                label: $translate('lang.E3202103250010', { defaultText: '请求参数' }),
                align: 'center',
                prop: 'requestBody',
                type: 'hint',
                filter: true,
                require: true,
                width: 100
            },
            {
                label: $translate('lang.E3202103250011', { defaultText: '执行耗时(ms)' }),
                align: 'center',
                prop: 'excuteTime',
                filter: true,
                require: true,
                width: 100
            },
            {
                label: $translate('lang.E3202103250012', { defaultText: '执行结果' }),
                align: 'center',
                prop: 'result',
                type: 'hint',
                filter: true,
                require: true,
                width: 100
            },
            {
                label: $translate('lang.E3202103220023', { defaultText: '操作人' }),
                align: 'center',
                prop: 'opName',
                filter: true,
                require: true,
                width: 100
            },
            {
                label: $translate('lang.E3202103220013', { defaultText: '操作时间' }),
                align: 'center',
                prop: 'operationTime',
                filter: true,
                require: true,
                width: 100
            },
            {
                label: $translate('lang.E3202103250013', { defaultText: '异常' }),
                align: 'center',
                prop: 'exception',
                type: 'hint',
                filter: true,
                require: true,
                width: 100
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
        pageNo: 1,
        pageSizes: [10, 20, 30, 50, 100]
    },
    showPage: true
};
